import React from 'react';
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
import BreadcrumbOne from "../breadcrumb/BreadcrumbOne";
import SectionTitle from "../sectionTitle/SectionTitle";
import ContactOne from "./ContactOne";
const Contact = () => {
    return (
        <>
            <SEO title="Contact || IEEE ISSATSo Student Branch" />
            <Layout>
                <BreadcrumbOne 
                    title="What about if we"
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Contact"
                    Typed1="Meet"
                    Typed2="Talk"
                    Typed3="and Have fun!"
                />
                <div className="main-content">
                    {/* Start Contact Area  */}
                    <div className="rwt-contact-area rn-section-gap">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 mb--40">
                                    <SectionTitle
                                        textAlign = "text-center"
                                        radiusRounded = ""
                                        title = "Contact Form"
                                        description = "We are glad to answear all your suggestions and questions"
                                    />
                                </div>
                            </div>
                            <ContactOne />
                        </div>
                    </div>
                    {/* End Contact Area  */}
                </div>
            </Layout>
        </>
    )
}
export default Contact;